<template>
  <div class="empty-layout-wrapper">
    <div class="empty-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmptyLayout",
};
</script>

<style lang="scss" scoped>
.empty-layout-wrapper {
  width: 100%;
  min-height: var(--try-vh, 100dvh);

  .empty-content {
    width: 100%;
    min-height: var(--try-vh, 100dvh);
  }
}
</style>

